import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  ImageBackground,
  useWindowDimensions
} from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';
import {fontFamily} from '../../helpers/fontFamily';
import {colors} from '../../style/rulesEngine';
import {breakpointPhone, touchTargetMin} from '../../style/adminTools';

export const PANEL_GRADIENT_COLORS = [
  'rgba(17, 28, 41, 0.7)',
  'rgba(37, 60, 87, 0.55)',
  'rgba(92, 119, 143, 0.45)',
  'rgba(92, 119, 143, 0.45)',
  'rgba(37, 60, 87, 0.55)',
  'rgba(17, 27, 39, 0.7)'
];
export const PANEL_GRADIENT_LOCATIONS = [0.09, 0.19, 0.43, 0.58, 0.78, 0.92];

const AdminPlaceholderScreen = ({title, replacedBy, onOpenMenu}) => {
  const {width} = useWindowDimensions();
  const isPhone = width < breakpointPhone;

  return (
    <ImageBackground
      style={{flex: 1}}
      source={require('../../../assets/background.png')}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          height: 56,
          paddingHorizontal: 16
        }}>
        <TouchableOpacity
          testID="adminPlaceholderMenuButton"
          accessibilityLabel="Open menu"
          onPress={onOpenMenu}
          style={{
            width: touchTargetMin,
            height: touchTargetMin,
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <i className="icon-menu" style={{color: colors.text, fontSize: 24}} />
        </TouchableOpacity>
      </View>
      <View
        style={{
          paddingHorizontal: 16,
          paddingTop: isPhone ? 8 : 32,
          alignItems: 'center'
        }}>
        <LinearGradient
          colors={PANEL_GRADIENT_COLORS}
          locations={PANEL_GRADIENT_LOCATIONS}
          start={{x: 0, y: 0}}
          end={{x: 1, y: 1}}
          style={{
            width: '100%',
            maxWidth: 960,
            borderRadius: 20,
            padding: 20,
            boxShadow: '0px 0px 10px 0px rgba(255, 255, 255, 0.2)'
          }}>
          <Text
            accessibilityRole="header"
            style={{
              fontFamily: fontFamily.font700,
              fontSize: isPhone ? 22 : 28,
              color: colors.text
            }}>
            {title}
          </Text>
          <Text
            style={{
              fontFamily: fontFamily.font500,
              fontSize: 14,
              color: colors.textMuted,
              marginTop: 8
            }}>
            {`Placeholder. ${replacedBy} replaces this screen.`}
          </Text>
        </LinearGradient>
      </View>
    </ImageBackground>
  );
};

export default AdminPlaceholderScreen;
